export const DOC_TYPE_REQUIRED = 1;
export const DOC_TYPE_INTERNAL = 2;
export const DOC_TYPE_DOWNLOADABLE = 3;

export type DocTypeEnumType =
    | typeof DOC_TYPE_REQUIRED
    | typeof DOC_TYPE_INTERNAL
    | typeof DOC_TYPE_DOWNLOADABLE;

export const documentTypes = [
    {
        value: DOC_TYPE_REQUIRED,
        label: 'Document à envoyer par le prescripteur',
        code: 'required',
        name: 'requis',
    },
    { value: DOC_TYPE_INTERNAL, label: 'Document interne', code: 'internal', name: 'interne' },
    {
        value: DOC_TYPE_DOWNLOADABLE,
        label: 'Document retourné par organisme traitant',
        code: 'downloadable',
        name: 'remis',
    },
] as const;

export const findLabelByDocTypeId = (id: number) => {
    const document = documentTypes.find((doc) => doc.value === id);
    if (document) {
        return document.label;
    }
    return 'Non trouvé';
};
